// extracted by mini-css-extract-plugin
export default {"container":"BIXmPnklhY_Nrvjz0_Fw"};